import { render, staticRenderFns } from "./UploadFileItem.vue?vue&type=template&id=2b617100&"
import script from "./UploadFileItem.vue?vue&type=script&lang=ts&"
export * from "./UploadFileItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports